import Vue from 'vue'
import Router from 'vue-router'
import MainLayout from '@/layout/MainLayout'

Vue.use(Router)

export default new Router({
  linkExactActiveClass: 'active',
  routes: [
    {
      path: '/',
      redirect: 'UserReport',
      component: MainLayout,
      children: [
        {
          path: '/user-report/:hash',
          name: 'UserReport',
          component: () => import(/* webpackChunkName: "about" */ './views/UserReport.vue')
        }
      ]
    }
  ]
})
